
export const borderRadius = {
  name: 'border-radius'
}

export const borderTopLeftRadius = {
  name: 'border-top-left-radius'
}

export const borderTopRightRadius = {
  name: 'border-top-right-radius'
}

export const borderBottomLeftRadius = {
  name: 'border-bottom-left-radius'
}

export const borderBottomRightRadius = {
  name: 'border-bottom-right-radius'
}